import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Signup() {
  const navigate = useNavigate();
  const { signup } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", company: "", password: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) { toast.error("Mot de passe trop court (6 caractères min)"); return; }
    setLoading(true);
    try {
      await signup(form);
      toast.success("Compte créé · 7 jours d'essai");
      navigate("/app");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Échec d'inscription");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div className="flex-1 flex items-center justify-center p-8 lg:p-12">
        <div className="w-full max-w-sm">
          <div className="text-xs tracking-[0.3em] uppercase text-slate-500 mb-2">Inscription</div>
          <h1 className="font-display text-3xl tracking-tight mb-2">Démarrez votre essai.</h1>
          <p className="text-slate-500 text-sm mb-8">7 jours gratuits · pas de carte requise</p>
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-wider text-slate-500">Nom</Label>
              <Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-2 h-11" data-testid="signup-name-input" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider text-slate-500">Email pro</Label>
              <Input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-2 h-11" data-testid="signup-email-input" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider text-slate-500">Entreprise</Label>
              <Input value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} className="mt-2 h-11" data-testid="signup-company-input" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider text-slate-500">Mot de passe</Label>
              <Input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-2 h-11" data-testid="signup-password-input" />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11 bg-[#2563EB] hover:bg-[#1D4ED8] btn-pill" data-testid="signup-submit-btn">
              {loading ? "Création…" : "Créer mon compte"}
            </Button>
          </form>
          <div className="mt-6 text-sm text-slate-500">
            Déjà inscrit ? <Link to="/login" className="text-[#2563EB] font-medium link-underline" data-testid="signup-login-link">Se connecter</Link>
          </div>
        </div>
      </div>

      <div className="hidden lg:flex lg:w-1/2 bg-[#0F172A] text-white relative">
        <div className="absolute inset-0 bg-grid opacity-10" />
        <div className="relative p-12 flex flex-col justify-between w-full">
          <Link to="/" className="font-display text-2xl tracking-tight">Xpert Recruit AI</Link>
          <div className="space-y-5">
            <div className="text-xs tracking-[0.3em] uppercase text-slate-400">Ce qui vous attend</div>
            <ul className="space-y-3 text-slate-200">
              <li className="font-display text-xl">→ Justifications traçables</li>
              <li className="font-display text-xl">→ Plans d'entretien complets</li>
              <li className="font-display text-xl">→ Triage anti-erreurs</li>
              <li className="font-display text-xl">→ Copilote de décision</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
